import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchSuggestions } from 'b2b-apps/shop/catalog/redux/suggestions/actionCreators';

export type UseFetchSuggestionsActionReturnType = typeof fetchSuggestions;
export function useFetchSuggestionsAction(): UseFetchSuggestionsActionReturnType {
  const dispatch = useDispatch();
  return bindActionCreators(fetchSuggestions, dispatch);
}
